import styled from "styled-components";
const privacypolicyonlinePageDisplay = styled.div`
	padding: 20px 30px;
	min-height: 100vh;
	color :black;
	
`;	export default privacypolicyonlinePageDisplay;
